import React, {Component} from 'react';
import {Modal, InputItem, Checkbox, Toast} from 'antd-mobile';
import {
    getShiftDetail,
    submitOrder,
    newWxPay,
    couponlistperson,
    walletCode,
    walletBalance,
} from '../../../service/homeService';
import SpecialPage from '../../../components/SpecialPage'
import "./style.less";
import {connect} from "react-redux";
import PayModal from "../../../components/PayModal";
import {getOftenList} from "../../../service/memberService";
import TestCode from "../../../components/TestCode";
import InsuranceModal from "../../../components/InsuranceModal";
import PriceModal from "../../../components/PriceModal";
const cardSfz = require('../../../common/image/cardSfz.png');
const refundimg = require('../../../common/image/refundimg.png');
const dog = require('../../../common/image/dog.png');
const baby = require('../../../common/image/baby.png');
const box = require('../../../common/image/box.png');
const child = require('../../../common/image/child.png');
const yixuan = require('../../../common/image/yixuan.png');
const kexuan = require('../../../common/image/kexuan.png');
const xuanzhong = require('../../../common/image/xuanzhong.png');
const CheckboxItem = Checkbox.CheckboxItem;
let integralList = [];
let isSubmit = false;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class SelectSeat extends Component {
    constructor(props) {
        super(props);
        if (isSubmit) {
            isSubmit = false;
            props.history.goBack();
        }
        this.state = {
            discountsModal:false,//优惠选择框
            noticeModal:false,
            userPhone:this.props.userInfo.phone,
            heightFlag:false,
            priceTotal:0,
            seatSelIndex:'',
            data: [],
            integralList:[],
            seatData:[],
            currentSeat:"",
            protocolVal:false,//同意协议
            discountList:[],
            psgData:[],
            payModal:false,
            payData:"",
            formPay:"",
            babyVal:false,//儿童座选择
            babyModal:false,
            codeModal:false,
            getCodeDisabled: false,
            getCodeText: '重新获取',
            balance:"",
            insuranceModal:false,
            insuranceData:[ 
                // {key:0,checkBox:false,name:"疫情隔离津贴险",discript:"新冠隔离可补贴￥300元",price:40,chanpin:"产品介绍",xuzhi:"须知须知须知"},
                // {key:1,checkBox:false,name:"疫情隔离津贴险1",discript:"新冠隔离可补贴￥301元",price:41,chanpin:"产品介绍111",xuzhi:"须知须知须知1111"},
            ],
            insuranceIndex:0,
            priceModal:false,
            priceDetail:false,
            priceInfo:{},
        };
    }
    componentDidMount() {
        walletBalance({token:this.props.userInfo.token,source:1}).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({balance:res.data.data.balance,})
            }
        });
        integralList = [];
        //处理弹起按钮事件
        // let screenHeight = document.body.offsetHeight;
        // let that =this;
        // window.onresize = function() {
        //     let nowHeight = document.body.offsetHeight;
        //     if(nowHeight < screenHeight) {
        //         that.setState({heightFlag: true});
        //     } else {
        //         that.setState({heightFlag: false});
        //     }
        // };
        let props = this.props.location.state;
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                id:props.id,//班次id
                startStationId:props.startStationId,//出发站点id
                startPosition:props.startPosition,//出发经纬度
                startAddress:props.startAddress,//出发具体地址
                endStationId:props.endStationId,
                endPosition:props.endPosition,
                endAddress:props.endAddress,
            },
        };
        getShiftDetail(params).then((res)=>{
            if(res.data.code === '0000'){
                let discountParams = {
                    source: 1,
                    token:this.props.userInfo.token,
                    data:{
                        lineId:res.data.data.lineId,
                        couponOrderType:0,
                    },
                };
                couponlistperson(discountParams).then((res)=>{
                    if(res.data.code === '0000'){
                        Toast.hide();
                        this.setState({discountList:res.data.data})
                    }else{
                        Toast.info(res.data.msg)
                    }
                });
                res.data.data.seatList.map((r)=>{
                    r.actualPrice = r.totalPrice;//totalPrice座位价格
                    r.flag = false;//是否选中座位
                    r.checkBox = false;//是否选择使用积分
                    r.integral = 0;//每个座位可抵扣积分
                    r.discount = 0;//优惠券抵扣金额
                    r.discountId = "";//优惠券id
                    r.deductionPic = 0;//积分抵扣金额
                    //totalPrice:座位总金额 = 座位价格+接分流价格+送分流价格
                    //seatPrice:座位价格 pickUpPrice:接分流价格 deliveryPrice:送分流价格
                    //integral:积分抵扣  discount:优惠券抵扣金额
                    //actualPrice:成人:totalPrice-integral-discount; 儿童座不能使用积分优惠券:seatPrice*儿童座优惠比例(childPriceRatio)+pickUpPrice+deliveryPrice
                });
                this.setState({seatData:res.data.data});
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    reserveModal(){
        this.setState({priceModal: false});
        let props = this.props.location.state;
        if(this.state.currentSeat == "" && props.specialPage == 0){
            Toast.info("请选择座位");
            return
        }
        if(this.state.currentSeat == "" && props.specialPage == 1){
            Toast.info("请添加/选择联系人");
            return
        }
        if(this.state.userPhone === "" || this.state.userPhone === null){
            Toast.info("请输入电话号码");
            return
        }
        this.setState({noticeModal: true});
    }
    protocolChange =(e)=>{
        this.setState({protocolVal:e.target.checked});
    };
    //婴幼儿弹窗
    babyOK = () => {
        return (
            <Modal
                className="babyModal"
                visible={this.state.babyModal}
                transparent
                maskClosable={false}
                onClose={()=>this.setState({babyModal:false})}
                footer={[{text: '知道了', onPress: () => this.setState({babyModal:false})}]}
            >
                <div className="babyTips">
                    <div className="title">关于儿童票说明</div>
                    <div className="column">
                        1: 儿童座优惠规则以选座页面为准，<span>不参与活动优惠、积分抵扣，不支持改签</span>；
                    </div>
                    <div className="column">
                        2: <span>身高未超过1.1米</span>的小孩视为儿童，可以购买儿童坐；
                    </div>
                    <div className="column">
                        3: <span>单趟行程仅可购买一张儿童票；</span>
                    </div>
                    <div className="column">
                        4: <span>8岁以下儿童</span>需有监护人陪同方可乘车；
                    </div>
                    <div className="column">
                        5: 如不符合儿童标准购买儿童票的乘客，我们将拒绝提供服务。
                    </div>
                </div>
            </Modal>
        )
    };
    babyChange =(e)=>{
        if(this.state.currentSeat.length < 2){
            Toast.info("请选择大于两个座位！",2);
            return
        }
        let {currentSeat,seatData,integralList,priceInfo} = this.state;
        let props = this.props.location.state;
        let arr = []
        currentSeat.map((res,i)=>{
            if(seatData.seatList.length > 6){
                if(res.seatNum > 5){
                    arr.push(res)
                }
            }else if(seatData.seatList.length > 4){
                if(res.seatNum > 3){
                    arr.push(res)
                }
            }else if(seatData.seatList.length > 2){
                if(res.seatNum > 1){
                    arr.push(res)
                }
            }
            
        })
        if(arr.length < 2 && props.specialPage !== 1){
            Toast.info("儿童座和陪同人员只能为最后一排！",2);
            return
        }
        let max = 0;
        let priceTotal =this.state.priceTotal;
        if(e.target.checked){
            this.setState({babyModal:true});
            for (let i=0;i<currentSeat.length;i++){
                if(currentSeat[max].seatNum <= currentSeat[i].seatNum){
                    max = i;
                }
            }
        }else{
            priceTotal = priceInfo.baoxian || 0;
            for (let i=0;i<currentSeat.length;i++){
                if(currentSeat[i].isChild = 1){
                    currentSeat[i].actualPrice = currentSeat[i].totalPrice - currentSeat[i].integral - currentSeat[i].discount;
                }
                currentSeat[i].isChild = 0;
                priceTotal += parseFloat(currentSeat[i].actualPrice.toFixed(2));
            }
        }
        if(max > 0){
            currentSeat[max].isChild = 1;
            currentSeat[max].actualPrice=parseFloat((currentSeat[max].seatPrice * seatData.childPriceRatio + currentSeat[max].pickUpPrice + currentSeat[max].deliveryPrice).toFixed(2));
            priceTotal=parseFloat((priceTotal+currentSeat[max].discount+currentSeat[max].integral-(currentSeat[max].totalPrice - currentSeat[max].actualPrice)).toFixed(2));
            if(currentSeat[max].checkBox){
                currentSeat[max].checkBox = false;
                currentSeat[max].integral = 0;
            }
        }
        // console.log(currentSeat[max],currentSeat,integralList);
        this.setState({babyVal:e.target.checked,currentSeat,priceTotal});
    };
    //乘车须知
    orderSubmit = () => {
        return (
            <Modal
                className="noticeModal1"
                visible={this.state.noticeModal}
                transparent
                closable={true}
                maskClosable={false}
                onClose={()=>this.setState({noticeModal:false})}
                footer={[{text: '知道了', onPress: () => this.reserve()}]}
            >
                <div style={{ marginTop:'15px' }}>预约须知</div>
                <div className="passengerTips">
                    <div className="red" style={{fontWight:'600'}}>提示：距离出发时间不足两小时，购买后不支持取消订单和变更行程</div>
                    <div className="column">
                        <img alt="" src={refundimg}/>
                        {/* <div>根据网约车监管政策要求，乘车应<span>携带有效证件</span>，上车前需要<span>实名登记</span>。</div> */}
                        <div><span style={{fontWeight:'600',color:'#616372'}}>退改签规则：</span>行程出发<span style={{color:'red'}}>2小时内不支持退改签</span>；2~12小时退票收取座位费的20%，改签收取10%；12~24小时退改签收取座位费的5%；24小时以上不收取违约金。<span>低价座位改签到高价座位时须补全差价，高价座位改签到低价座位时不退差价</span>。</div>
                    </div>
                    <div className="column">
                        <img alt="" src={cardSfz}/>
                        <div>根据网约车监管政策要求，乘车应<span>携带有效证件</span>，上车前需要<span>实名登记</span>。</div>
                    </div>
                    <div className="column">
                        <img alt="" src={child}/>
                        <div>应国家相关法律法规的要求，<span>婴幼儿乘车</span>需要计费，详细规则请查看《乘车须知》中有关婴幼儿乘车的规定。</div>
                    </div>
                    <div className="column">
                        <img alt="" src={dog}/>
                        <div><span>携带宠物</span>乘车的乘客，请在下单前请与客服联系，确认预约车辆是否允许携带宠物。</div>
                    </div>
                    <div className="column">
                        <img alt="" src={box}/>
                        <div><span>携带行李</span>乘车的乘客，请详细阅读《乘车须知》中有关行李重量和尺寸的规定。</div>
                    </div>
                    {/*<div className="column">
                        <img alt="" src={refund}/>
                        <div>距发车时间2小时内退票收取<span>50%</span>手续费，不允许改签；2-12小时退票、改签<span>20%</span>；12-24为<span>10%</span>；24小时以上退票<span>5%</span>、改签<span>0.01元</span>。
                        </div>
                    </div>
                    <div className="column">
                        <img alt="" src={invoice}/>
                        <div>电子发票免费开具，纸质发票收取10元邮寄费用；特殊要求请在发票申请备注内填写说明。<span>收取10元</span>邮寄费用；特殊要求请在发票申请备注内填写说明。</div>
                    </div>*/}
                </div>
                <div className="protocol">
                    <CheckboxItem  onChange={(e) => this.protocolChange(e)} checked={this.state.protocolVal}>
                        平台提供同行程（既拼车）出行服务，未尽事宜请点击 <div onClick={() => this.props.history.push('/userAgreement')}>《民途出行用户协议》</div>查阅，勾选点击知道了既代表您同意合乘服务及协议内容
                    </CheckboxItem>
                </div>
            </Modal>
        )
    };
    reserve(){
        console.log(this.state.insuranceData)
        console.log(this.state.priceInfo)
        if(this.state.protocolVal === false){
            Toast.info("请同意用户协议后购票");
            return
        }
        let props = this.props.location.state;
        let currentSeat = this.state.currentSeat;
        let data = this.state.integralList;
        data.map((res,i)=>{
            currentSeat.map((r)=>{
                if(r.seatNum === res.seatNum){
                    if(r.totalPrice - res.integral - res.discount <= 0){
                        r.actualPrice = 0;
                    }else{
                        if(r.isChild == 1){
                            r.actualPrice = parseFloat((r.seatPrice * this.state.seatData.childPriceRatio + r.pickUpPrice+r.deliveryPrice).toFixed(2)) ;
                            r.integral = 0;
                            r.discount = 0;
                            r.discountId = "";
                        }else{
                            r.actualPrice = parseFloat((r.totalPrice - res.integral - res.discount).toFixed(2)) ;
                        }
                    }
                    r.integral = Math.ceil(res.integral);
                }
            });
        });
        this.setState({data,currentSeat,noticeModal: false});
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                source:1,
                lineId:this.state.seatData.lineId,
                shiftId:props.id,//班次id
                startCity:this.state.seatData.startCity,
                startStationId:props.startStationId,//出发站点id
                startPosition:props.startPosition,//出发经纬度
                startAddress:props.startAddress,//出发具体地址
                endCity:this.state.seatData.endCity,
                endStationId:props.endStationId,
                endPosition:props.endPosition,
                endAddress:props.endAddress,
                phone:this.state.userPhone,
                seats:this.state.currentSeat,
                totalPrice:parseFloat(this.state.priceTotal).toFixed(2) <= 0 ? 0 : parseFloat(this.state.priceTotal).toFixed(2),
                sourceAccountId:sessionStorage.getItem("sourceAccountId"),
            },
        };
        Toast.loading("",0);
        submitOrder(params).then((res)=>{
            if(res.data.code === '0000'){
                Toast.hide();
                if(parseFloat(this.state.priceTotal.toFixed(2)) <= 0){
                    isSubmit = true;
                    this.props.history.push(`/payFinish/${res.data.data}`, {orderType: 1,specialPage:this.props.location.state.specialPage});
                }else{
                    this.setState({payModal:true,payData:res.data.data});
                }
            }else{
                this.setState({noticeModal: false});
                Toast.info(res.data.msg,3);
            }
        });
    }
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        if(e == "工商银行支付"){
            this.weiXinPay(this.state.payData,"icbcjft");
        }
        if(e== "微信支付"){
            this.weiXinPay(this.state.payData,"wx");
        }
        if(e == "民途钱包余额支付"){
            this.setState({payModal:false});
            this.getCode();
        }
    }
    weiXinPay = (orderNo,type,v) => {
        Toast.loading("",0);
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                source: 1,
                orderId: orderNo,
                payChannel:type,
                smsCode:v,
            }
        };
        newWxPay(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                if(type == "wx"){
                    this.wxBridgeReady(res.data.data, orderNo);
                }else if(type == "wallet"){
                    isSubmit = true;
                    this.props.history.push(`/payFinish/${orderNo}`, {orderType: 1,specialPage:this.props.location.state.specialPage});
                }else{
                    isSubmit = true;
                    // window.location.href = res.data.data.qrcode;
                    this.setState({formPay:res.data.data,});
                }
            } else {
                isSubmit = true;
                // this.setState({noticeModal: false});
                Toast.info(res.data.msg,2,()=>this.props.history.push(`/pay/myOrder`,));
            }
        }).catch(function (error) {
            console.log(error);
        })
    };
    wxBridgeReady = (bridgeInfo, orderNo) => {
        const self = this;
        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": bridgeInfo.appId,         //公众号名称，由商户传入
                    "timeStamp": bridgeInfo.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": bridgeInfo.nonceStr,   //随机串
                    "package": bridgeInfo.package,     //prepay_id
                    "signType": bridgeInfo.signType,   //微信签名方式
                    "paySign": bridgeInfo.sign         //微信签名
                },
                function (r) {
                    isSubmit = true;
                    if (r.err_msg === "get_brand_wcpay_request:ok") {
                        self.props.history.push(`/payFinish/${orderNo}`, {orderType: 1,specialPage:self.props.location.state.specialPage});
                    } else if (r.err_msg === "get_brand_wcpay_request:cancel") {
                        Toast.info('您取消了支付，可到订单详情支付', 2, () => {
                            self.props.history.push(`/pay/myOrder`,);
                        });
                    } else if (r.err_msg === "get_brand_wcpay_request:fail") {
                        Toast.info('支付失败，请稍后重试', 2, () => {
                            self.props.history.push(`/pay/myOrder`,);
                        });
                    }
                }
            );
        }
        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };
    changePone(e){
        this.setState({userPhone:e});
    }
    //选座位/更换
    // selSeat(i,r) {
    //     let currentSeat = [];
    //     let priceTotal = 0;
    //     let price =0;
    //     const {seatData} = this.state;
    //     if(r.status === 1){
    //         r.flag =!r.flag;
    //         this.setState({seatSelIndex:i});
    //         seatData.seatList.map((res,)=>{
    //             if(res.flag === true && res.status === 1){
    //                 priceTotal += parseFloat(res.totalPrice);
    //                 currentSeat.push(res);
    //             }
    //         });
    //         // if(seatData.userIntegral > 0 && r.flag === true && seatData.integral > 0){
    //         if(seatData.userIntegral == 0 && r.flag === true && seatData.integral == 0){
    //             if(seatData.userIntegral <= seatData.integral){
    //                 r.deductionPic = seatData.userIntegral;
    //                 seatData.userIntegral = seatData.userIntegral - r.deductionPic;
    //                 integralList.push(r);
    //             }
    //             if(seatData.userIntegral > seatData.integral){
    //                 r.deductionPic = seatData.integral;
    //                 seatData.userIntegral = seatData.userIntegral - r.deductionPic;
    //                 integralList.push(r);
    //             }
    //         }
    //         this.setState({seatData});
    //
    //         if(integralList){
    //             integralList.map((g,index)=>{
    //                 if(r.seatNum === g.seatNum && r.flag === false){
    //                     seatData.userIntegral = seatData.userIntegral + r.deductionPic;
    //                     g.checkBox = false;
    //                     integralList.splice(index,1);
    //                 }
    //                 if(g.checkBox === true){
    //                     price += g.deductionPic;
    //                 }
    //             });
    //         }
    //         priceTotal =parseFloat(priceTotal-price);
    //         this.setState({priceTotal,integralList,currentSeat});
    //         // console.log(priceTotal,currentSeat,integralList)
    //     }
    // }
    //选座位/更换
    selSeat(i,r) {
        let props = this.props.location.state;
        let currentSeat = [];
        let priceTotal = 0;
        let price =0;
        let discountPic = [];
        let discountRatio  = [];
        let newDiscount = [];
        const {seatData,insuranceData,priceInfo} = this.state;
        if(r.status === 1){
            r.flag =!r.flag;
            r.seatIndex = i;
            //优惠券默认最大优惠
            this.state.discountList.map((res,discountIndex)=>{
                //使用限制不管是限制还是满减只要票价格小于等于满减金额当前优惠券就可以用
                if(r.seatPrice >= res.useLimitAmount){
                    //如果是固定金额
                    if(res.couponType == 1){
                        //优惠总价低于票价的50%，直接抵扣优惠金额
                        if(r.seatPrice/2 >= res.couponAmount){
                            //res.couponAmount:实际优惠价格
                            discountPic.push({pic:res.couponAmount,id:res.id,discountIndex:discountIndex,couponName:res.couponName})
                        }
                        //优惠总价高于票价的50%，抵扣票价金额的50%
                        if(r.seatPrice/2 < res.couponAmount){
                            discountPic.push({pic:r.seatPrice/2,id:res.id,discountIndex:discountIndex,couponName:res.couponName})
                        }
                    }
                    //如果是固定比例
                    if(res.couponType == 2){
                        discountRatio.push({pic:r.seatPrice*res.discountRatio,id:res.id,discountIndex:discountIndex,couponName:res.couponName})
                    }
                }
            });
            newDiscount =discountPic.concat(discountRatio);
            let max = 0;
            seatData.seatList.map((s,)=>{
                for (let i=0;i<newDiscount.length;i++){
                    if(s.flag === true && s.status === 1){
                        if(newDiscount[i].id == s.discountId){
                            newDiscount.splice(i, 1);
                        }
                    }
                }
            });
            for (let i=0;i<newDiscount.length;i++){
                if(newDiscount[max].pic <= newDiscount[i].pic){
                    max = i
                }
            }
            if(r.flag == true && newDiscount.length > 0){
                r.discount = parseFloat((newDiscount[max].pic).toFixed(2));
                r.discountId = newDiscount[max].id;
                r.couponName = newDiscount[max].couponName;
            }
            if(r.flag == false){
                r.discount = 0;//优惠券价格
                r.discountId = "";//优惠券id
                r.couponName = "";//优惠券名称
                seatData.userIntegral = seatData.userIntegral + r.deductionPic;
                r.deductionPic = 0;//优惠券价格
                r.actualPrice = r.totalPrice;
                r.contactsId = "";
                r.contactsIdNum = "";
                r.contactsName = "";
            }
            if(seatData.userIntegral > 0 && r.flag === true && seatData.integral > 0){
                //线路可用积分8,优惠后座位价格5,用户账户积分22
                let integralPic = [];
                let min =0;
                if(r.discount > 0){
                    integralPic.push(seatData.integral,parseFloat((r.seatPrice-r.discount).toFixed(2)),seatData.userIntegral);
                    for (let i=0;i<integralPic.length;i++){
                        if(integralPic[min] > integralPic[i]){
                            min = i;
                        }
                    }
                    r.deductionPic = integralPic[min];
                    seatData.userIntegral = seatData.userIntegral - r.deductionPic;
                    integralList.push(r);
                }else{
                    integralPic.push(seatData.integral,r.seatPrice,seatData.userIntegral);
                    for (let i=0;i<integralPic.length;i++){
                        if(integralPic[min] > integralPic[i]){
                            min = i;
                        }
                    }
                    r.deductionPic = integralPic[min];
                    seatData.userIntegral = seatData.userIntegral - r.deductionPic;
                    integralList.push(r);
                }
            }else if(seatData.userIntegral <= 0 && r.flag === true && this.state.discountList.length > 0){
                integralList.push(r);
            }else if(seatData.userIntegral <= 0 && r.flag === true && this.state.discountList.length <= 0 && props.specialPage == 1){
                integralList.push(r);
            }
            if(seatData.defaultUseIntegral == 1){
                r.checkBox = true
                r.integral = r.deductionPic;
            }
            seatData.seatList.map((res,)=>{
                if(res.flag === true && res.status === 1){
                    if(res.checkBox){
                        res.actualPrice = parseFloat((res.totalPrice - res.deductionPic - res.discount).toFixed(2));
                    }else{
                        res.actualPrice = parseFloat((res.totalPrice - res.discount).toFixed(2));
                    }
                    if(res.actualPrice < 0){
                        res.actualPrice = 0
                    }
                    priceTotal += parseFloat(res.actualPrice.toFixed(2));
                    currentSeat.push(res);
                }
            });
            if(integralList){
                integralList.map((g,index)=>{
                    if(r.seatNum === g.seatNum && r.flag === false){
                        // seatData.userIntegral = seatData.userIntegral + r.deductionPic;
                        g.checkBox = false;
                        integralList.splice(index,1);
                    }
                    // if(g.checkBox === true){
                    //     price += g.deductionPic;
                    // }
                });
            }
            //儿童选择
            if(this.state.babyVal){
                let selMax = 0;
                seatData.seatList.map((res)=>{
                    res.isChild = 0;
                });
                let arr = []
                currentSeat.map((res,i)=>{
                    if(seatData.seatList.length > 6){
                        if(res.seatNum > 5){
                            arr.push(res)
                        }
                    }else if(seatData.seatList.length > 4){
                        if(res.seatNum > 3){
                            arr.push(res)
                        }
                    }else if(seatData.seatList.length > 2){
                        if(res.seatNum > 1){
                            arr.push(res)
                        }
                    }
                    
                })
                if(arr.length >= 2){
                    for (let i=0;i<currentSeat.length;i++){
                        if(currentSeat[selMax].seatNum <= currentSeat[i].seatNum){
                            selMax = i;
                        }
                    }
                    if(selMax > 0){
                        currentSeat[selMax].isChild = 1;
                        currentSeat[selMax].actualPrice=parseFloat((currentSeat[selMax].seatPrice * seatData.childPriceRatio+currentSeat[selMax].pickUpPrice+currentSeat[selMax].deliveryPrice).toFixed(2));
                        priceTotal=parseFloat((priceTotal+currentSeat[selMax].discount+currentSeat[selMax].integral-(currentSeat[selMax].totalPrice - currentSeat[selMax].actualPrice)).toFixed(2));
                        if(currentSeat[selMax].checkBox){
                            currentSeat[selMax].checkBox = false;
                            currentSeat[selMax].integral = 0;
                        }
                    }
                }else{
                    Toast.info("儿童座和陪同人员只能为最后一排！",2);
                    this.setState({babyVal:false})
                }
            }
            this.setState({seatData});
            // let info = {}
            // let baoxian = 0
            // if(currentSeat.length > 0){
            //     insuranceData.map((k)=>{
            //         if(k.checkBox){
            //             info = Object.assign({}, this.state.priceInfo, { baoxian: k.price*currentSeat.length })
            //             baoxian = k.price*currentSeat.length
            //         }
            //     })
            // }else{
            //     insuranceData.map((k)=>{
            //         k.checkBox = false
            //     })
            //     info = Object.assign({}, this.state.priceInfo, { baoxian: 0 })
            //     baoxian = 0
            // }
            // priceTotal=parseFloat((priceTotal+baoxian).toFixed(2))
            
            // priceTotal =parseFloat(priceTotal-price);
            // this.setState({priceTotal,integralList,currentSeat,priceInfo:info});
            this.setState({priceTotal,integralList,currentSeat});
        }
    }
    //选择积分
    checkChange = (val,e) => {
        // console.log(val,e.target.checked);
        if(val.isChild == 1){
            Toast.info("儿童坐不可使用！");
            return
        }
        let pic = this.state.priceTotal;
        // let only = (val.totalPrice - val.discount -val.deductionPic) > 0 ? val.deductionPic : val.totalPrice - val.discount;
        if(e.target.checked === true){
            val.checkBox = true;
            val.integral = val.deductionPic;
            val.actualPrice = (val.totalPrice - val.discount -val.deductionPic) > 0 ? (val.totalPrice - val.discount -val.deductionPic) : 0  ;
            pic = pic-val.deductionPic;
        }else if(e.target.checked === false){
            val.checkBox = false;
            val.integral = 0;
            val.actualPrice = val.totalPrice - val.discount;
            pic= pic+val.deductionPic
        }
        this.setState({priceTotal:pic});
    };
    //优惠券列表
    discountCoupon=()=>{
        return(
            <Modal
                className="discountsModal"
                closable={true}
                popup
                visible={this.state.discountsModal}
                animationType="slide-up"
                onClose={()=>this.setState({discountsModal:false})}
            >
                <div className="discountWrap">
                    <div className="titleText">优惠券</div>
                    <div className="content">
                        <div className="not" onClick={()=>this.nonuse()}>不使用优惠券</div>
                        {
                            this.state.discountList.map((res,i)=>(
                                <div className="list" key={i} onClick={()=>this.changeDiscount(res)}>
                                    <div className="left">
                                        {res.couponType == 1 ? <p className="pic">￥<span>{parseFloat(res.couponAmount).toFixed(2)}</span></p> : <p className="pic"><span>{res.couponRatio * 10}</span> 折</p>}
                                        {res.limitType == 1 ? <p>无限制</p> :<p>满{res.useLimitAmount}可用</p>}
                                    </div>
                                    <div className="right">
                                        <p className="title">{res.couponName}</p>
                                        <p className="time">有效期：{res.allotTime}</p>
                                        <div>
                                            <span>{res.lineName == '全部线路' ? "全部线路可用" : "部分线路可用"}</span>
                                            {/*<span>规则明细 <i className="icon iconfont icontiaozhuan1"/> </span>*/}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        {/*<div className="list">
                            <div className="left">
                                <p className="pic"><span>5.8</span> 折</p>
                                <p>满300可用</p>
                            </div>
                            <div className="right">
                                <p className="title">新用户注册专享券</p>
                                <p className="time">有效期：2019.05.11 — 2019.07.30</p>
                                <div>
                                    <span>部分线路可用</span>
                                    <span>规则明细 <i className="icon iconfont icontiaozhuan1"/> </span>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                </div>
            </Modal>
        )
    };
    //不使用优惠券
    nonuse(){
        let seatData = this.state.seatData;
        let seat = this.state.seatData.seatList[this.state.seatSelIndex];
        let priceTotal = 0;
        let integralPic = [];
        let min =0;
        seat.discount = 0;
        seat.discountId = "";
        seat.couponName = "";
        seatData.userIntegral = seatData.userIntegral + seat.deductionPic;
        integralPic.push(seatData.integral,seat.totalPrice,seatData.userIntegral);
        for (let i=0;i<integralPic.length;i++){
            if(integralPic[min] > integralPic[i]){
                min = i;
            }
        }
        seat.deductionPic = integralPic[min];
        seatData.userIntegral = seatData.userIntegral - seat.deductionPic;
        this.state.seatData.seatList.map((res,)=>{
            if(res.flag === true && res.status === 1){
                if(res.checkBox){
                    res.actualPrice = parseFloat((res.totalPrice - res.deductionPic - res.discount).toFixed(2));
                }else{
                    res.actualPrice = parseFloat((res.totalPrice - res.discount).toFixed(2));
                }
                priceTotal += parseFloat(res.actualPrice.toFixed(2));
            }
        });
        this.setState({priceTotal,seatData:seatData,discountsModal:false})
    }
    //切换优惠券
    changeDiscount(e){
        let seatData = this.state.seatData;
        let seat = this.state.seatData.seatList[this.state.seatSelIndex];
        let seatFlag = true;
        let priceTotal = 0;
        if(seat.discountId == e.id){
            Toast.info("不能选择相同的优惠券",2);
            return
        }
        if(seat.discountId !== e.id){
            this.state.seatData.seatList.map((res)=>{
                if(res.discountId == e.id){
                    seatFlag = false;
                }
            });
            if(!seatFlag){
                Toast.info("此优惠券已被选中",2);
                return
            }
            if(seat.seatPrice < e.useLimitAmount){
                Toast.info("满减金额不足",2);
                return
            }
            if(seat.seatPrice >= e.useLimitAmount){
                if(e.couponType == 1 && seat.seatPrice/2 >= e.couponAmount){
                    seat.discount = e.couponAmount;
                }
                if(e.couponType == 1 && seat.seatPrice/2 < e.couponAmount){
                    seat.discount = seat.seatPrice/2;
                }
                if(e.couponType == 2){
                    seat.discount = parseFloat((seat.seatPrice*e.discountRatio).toFixed(2));
                }
            }
            let integralPic = [];
            let min =0;
            if(seat.discount > 0){
                seatData.userIntegral = seatData.userIntegral + seat.deductionPic;
                integralPic.push(seatData.integral,parseFloat((seat.seatPrice-seat.discount).toFixed(2)),seatData.userIntegral);
                for (let i=0;i<integralPic.length;i++){
                    if(integralPic[min] > integralPic[i]){
                        min = i;
                    }
                }
                seat.deductionPic = integralPic[min];
                seatData.userIntegral = seatData.userIntegral - seat.deductionPic;
            }
            seat.discountId = e.id;
            seat.couponName = e.couponName;
            this.state.seatData.seatList.map((res,)=>{
                if(res.flag === true && res.status === 1){
                    if(res.checkBox){
                        res.actualPrice = parseFloat((res.totalPrice - res.deductionPic - res.discount).toFixed(2));
                    }else{
                        res.actualPrice = parseFloat((res.totalPrice - res.discount).toFixed(2));
                    }
                    priceTotal += parseFloat(res.actualPrice.toFixed(2));
                }
            });
            this.setState({priceTotal,discountsModal:false,seatData})
        }
    }
    //打开优惠券列表
    openDiscount(i){
        this.setState({seatSelIndex:i.seatIndex});
        if(i.isChild == 1){
            Toast.info("儿童坐不可使用！");
            return
        }
        if(this.state.discountList.length > 0){
            this.setState({discountsModal:true});
        }else if(this.state.discountList.length == 0){
            Toast.info("您没有可用的优惠券")
        }
    }
    seatImg(res){
        if(res.status === 1 && res.flag === false){
            return <img alt="" src={kexuan} />
        }else if(res.status !== 1){
            return <img alt="" src={yixuan} />
        }else if(res.status === 1 && res.flag === true && res.isChild == 1){
            return <img alt="" src={baby} />
        }else{
            return <img alt="" src={xuanzhong} />
        }
    }
    getContent(){
        let props = this.props.location.state;
        const {seatData} = this.state;
        if(props.specialPage == 0){
            return(
                <div className="contentTop">
                    <div className="topBar">
                        <div className="city">
                            <span className="start">{seatData.startCity}</span>
                            <div><span>—</span><div className="carNum">{seatData.carNum}</div><span>—</span></div>
                            <span className="end">{seatData.endCity}</span>
                        </div>
                        <div className="time">
                            <span className="">{seatData.startTime}</span>
                            <span className="">{seatData.endTime}</span>
                        </div>
                        <p>{seatData.date} {seatData.weekend} {seatData.pickUpTime}开始接人</p>
                    </div>
                    <div className="selSeat">
                        <div className="seatTop">
                            <span className="title">预定座位</span>
                            <div className="bottom">
                                <div className="kexuan"><img alt="" src={kexuan} />可选</div>
                                <div className="xuanzhong"><img alt="" src={xuanzhong} />选中</div>
                                <div><img alt="" src={yixuan} />被选</div>
                            </div>
                        </div>
                        <div className="seatBottom">
                            <div className="title">
                                <div>前排</div>
                                <div className='middle'>中排</div>
                                {
                                    seatData.seatList.length > 6 ? <div className='middle'>中排</div> :null
                                }
                                <div>后排</div>
                            </div>
                            <div className="seatsBox">
                                <div className="selected">
                                    <img alt="" src={yixuan} />
                                    <span>司机</span>
                                </div>
                                {
                                    seatData.seatList && seatData.seatList.map((res,i)=>(
                                        <div
                                            key={i}
                                            className={res.status !== 1 ? 'selected' : res.status === 1 && res.flag === false ? '' : 'sel' }
                                            style={seatData.seatList.length % 2 == 0 ? i > seatData.seatList.length - 4 ? {width: '31.33%'} : {} : {}}
                                            onClick={() => this.selSeat(i,res)}
                                        >
                                            {this.seatImg(res)}
                                            {/*{res.status !== 1 ? <img alt="" src={yixuan} /> : res.status === 1 &&  res.flag === false ? <img alt="" src={kexuan} /> :  <img alt="" src={xuanzhong} />}*/}
                                            {res.isChild == 1 ? <span>{'￥'+parseFloat((res.seatPrice*seatData.childPriceRatio+res.pickUpPrice+res.deliveryPrice).toFixed(2))}</span> :<span>{'￥'+res.totalPrice}</span>}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        {
                            this.state.seatData.child == 0 ? null :( this.state.seatData.isBaby == 0 ? (
                                <div className="setBabys con" >
                                    <div>
                                        <i className="icon iconfont iconertong"/>
                                        <span  className='title'>儿童订单</span>
                                        <span>一车仅限一位儿童</span>
                                    </div>
                                    <CheckboxItem  onChange={(e) => this.babyChange(e)} checked={this.state.babyVal}>
                                    </CheckboxItem>
                                </div>
                            ): <div className="setBabys con" >如有儿童(含婴幼儿)乘车请联系客服，当前儿童订单已售罄。</div>)
                        }
                    </div>
                    {
                        this.state.integralList == "" ? null :  (
                            <div className="integral">
                                <div className="top">
                                    <i className="icon iconfont iconjifen"/>
                                    <span  className='titL'>优惠活动</span>
                                    {/*<span  className='titR'> <i className="icon iconfont icontiaozhuan"/></span>*/}
                                </div>
                                {
                                    this.state.integralList.map((i,index)=>(
                                        <div key={index}>
                                            <p className="seatNum">{i.seatNum}号座位</p>
                                            <div className="con" >
                                                <span>积分</span>
                                                <span className="">抵扣<span className="integralPic">￥{i.deductionPic}</span></span>
                                                <CheckboxItem  key={index} onChange={(e) => this.checkChange(i,e,index)} checked={i.checkBox}>
                                                </CheckboxItem>
                                            </div>
                                            <div className="con" onClick={()=>this.openDiscount(i)}>
                                                <span>优惠券</span>
                                                <span className={i.isChild == 1 ? "line" : null}>{i.couponName}<span className="integralPic">￥{i.discount}</span></span>
                                                <i className="icon iconfont icontiaozhuan"/>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>
            )
        }else{
            return (
                <SpecialPage
                    seatData={this.state.seatData}
                    integralList={this.state.integralList}
                    psgData={this.state.psgData}
                    babyVal={this.state.babyVal}
                    babyChange={this.babyChange.bind(this)}
                    selPagOk={this.selPagOk.bind(this)}
                    selSeat={this.selSeat.bind(this)}
                    openDiscount={this.openDiscount.bind(this)}
                    checkChange={this.checkChange.bind(this)}
                    getOftenList={this.getOftenList.bind(this)}
                    {...this.props}
                />
            )
        }
    }
    getOftenList(){
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {pageSize:100, pageNum:1}
        };
        //获取常用联系人
        getOftenList(params).then((res) => {
            if (res.data.code === '0000') {
                res.data.data.list.map((res)=>{
                    if(res.idType == 'idcard'){
                        res.numSelected = '身份证'
                    }
                    if(res.idType == 'passport'){
                        res.numSelected = '护照'
                    }
                    if(res.idType == 'borderCard'){
                        res.numSelected = '边民证'
                    }
                });
                this.setState({psgData: res.data.data.list,});
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    selPagOk(value){
        const {seatData} = this.state;
        // console.log(value)
        let flag = false;
        for(let i=0;i < seatData.seatList.length; i++){
            if(value.id == seatData.seatList[i].contactsId){
                Toast.info("不能选择相同联系人");
                return
            }
            if(seatData.seatList[i].status == 1 && seatData.seatList[i].flag == false){
                seatData.seatList[i].contactsId = value.id;
                seatData.seatList[i].contactsIdNum = value.idNum;
                seatData.seatList[i].contactsName = value.name;
                this.selSeat(i,seatData.seatList[i]);
                return
            }
            flag = true
        }
        if(flag){
            Toast.info("没有剩下可预约的位置")
        }
    }
    onClose = (v) => {
        Toast.info('您取消了支付，可到订单详情支付', 2, () => {
            this.props.history.push(`/pay/myOrder`,);
        });
        isSubmit = true;
    };
    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeDisabled: true,getCodeText: time + 's后获取'});
            } else {
                this.setState({getCodeText: '重新获取'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    getCode(){
        let params={
            token:this.props.userInfo.token,
            source:1,
            data:{
                source:3,
            }
        };
        walletCode(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setDownTime(60);
                this.setState({codeModal:true});
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    codeSubmit(v){
        if(v == ""){
            Toast.info("请输入验证码");
            return
        }
        this.setState({codeModal:false,});
        this.weiXinPay(this.state.payData,"wallet",v);
    }
    payFrom(){
        if(this.state.formPay !== ""){
            return(
                <form
                    name="auto_submit_form"
                    method="post"
                    action={this.state.formPay.url}>
                    <input
                        type="hidden"
                        name="biz_content"
                        value={this.state.formPay.bizContent} />
                    <input type="submit" value="立刻提交" style={{display:"none"}} onClick={setTimeout(()=>document.forms[0].submit(),100)}/>
                </form>
            )
        }else{
            return null
        }
    }
    //保险模块
    insuranceChange = (val,e,index) => {
        let props = this.props.location.state;
        if(this.state.currentSeat == "" && props.specialPage == 0){
            Toast.info("请选择座位");
            return
        }
        if(this.state.currentSeat == "" && props.specialPage == 1){
            Toast.info("请添加/选择联系人");
            return
        }
        let insuranceData = this.state.insuranceData;
        let pic = this.state.priceTotal;
        let info = {}
        insuranceData.map((res)=>{
            if(res.checkBox){
                pic = pic - res.price*this.state.currentSeat.length
            }
            res.checkBox = false;
        })
        if(e.target.checked === true){
            info = Object.assign({}, this.state.priceInfo, { baoxian: val.price*this.state.currentSeat.length })
            insuranceData[index].checkBox = true;
            pic = pic + val.price*this.state.currentSeat.length
        }
        this.setState({insuranceData,priceTotal:pic,priceInfo:info});
    };
    lookPriceDetail=()=>{
        let info = {}
        let price1 = 0;
        let price2 = 0;
        let price3 = 0;
        let childprice = 0;
        if(this.state.currentSeat){
            this.state.currentSeat.map((res)=>{
                if(res.isChild){
                    //儿童票价格
                    childprice = res.actualPrice
                }else{
                    //保险价格总和，成人座位价格总和，抵扣积分总和，抵扣优惠金额总和
                    price1 += res.totalPrice
                    price2 += res.integral
                    price3 += res.discount
                }
            })
            info = Object.assign({}, this.state.priceInfo, { totalPrice: price1,integral:price2,discount:price3,babyPrice:childprice })
        }
        this.setState({
            priceModal:!this.state.priceModal,
            priceDetail:!this.state.priceDetail,
            priceInfo:info
        })
    }
    render(){
        if(this.state.seatData.length <= 0){
            return null
        }
        return(
            <div className="selectSeat">
                <div className="goBack">
                    <i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />
                </div>
                <div className="warp">
                    <div className="content">
                        {this.getContent()}
                        <div className="userPhone">
                            预留手机
                            <InputItem
                                type="number"
                                ref={el => this.inputRef = el}
                                placeholder="请输入手机号"
                                value={this.state.userPhone}
                                onChange={(e)=>this.changePone(e)}
                            />
                            <span onClick={() => this.inputRef.focus()}>修改</span>
                        </div>
                        
                        {this.state.insuranceData.length > 0 ? 
                            <div className="insuranceBox">
                                <div className="tip">
                                    <i className="icon iconfont iconbaozhang_huaban11" />
                                    出行有保障，旅程更安心
                                </div>
                                <div className="box">
                                    {
                                        this.state.insuranceData.map((res,index)=>(
                                            <div className="insurance" key={index}>
                                                <div className="title">{res.name} <i className="icon iconfont icon2_huaban1" onClick={()=>this.setState({insuranceModal:true,insuranceIndex:index})} /></div>
                                                <div className="title describe">
                                                    <span>{res.discript}</span>
                                                    <div className="title">
                                                        <span className="price">{'￥'+res.price+'/人'}</span>
                                                        <CheckboxItem  key={index} onChange={(e) => this.insuranceChange(res,e,index)} checked={res.checkBox}></CheckboxItem>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    
                                </div>
                            
                            </div>:null}
                        {
                            this.state.seatData.notes == "" ? null : (
                                <div className="discript">
                                    <span>温馨提示：</span>
                                    <div>{this.state.seatData.notes}</div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className="footer" style={this.state.heightFlag === true ? {zIndex:-1} : {zIndex:0} }>
                    <div className="payTotal">合计：
                        <span>￥{parseFloat(this.state.priceTotal).toFixed(2) <= 0 ? 0 : parseFloat(this.state.priceTotal).toFixed(2)}</span>
                        <span className="minxi"  onClick={this.lookPriceDetail}>
                            明细 
                            <div style={{display:'inline-block',transition:'transform 0.3s linear',transform:this.state.priceDetail ? 'rotate(180deg)' : 'rotate(0deg)'}}><i className="icon iconfont iconjiantou_huaban1" /></div>
                    </span>
                    </div>
                    <button className="go" onClick={() => this.reserveModal()}>立即支付</button>
                </div>
                {this.discountCoupon()}
                {this.orderSubmit()}
                <PayModal
                    modal={this.state.payModal}
                    onClose={this.onClose.bind(this)}
                    payType={this.payType.bind(this)}
                    businessType={"intercity"}
                    balance={this.state.balance}
                />
                {this.payFrom()}
                {this.babyOK()}
                <TestCode
                    modal={this.state.codeModal}
                    onClose={this.onClose.bind(this)}
                    againEvent={this.getCode.bind(this)}
                    getCodeDisabled={this.state.getCodeDisabled}
                    getCodeText={this.state.getCodeText}
                    codeSubmit={this.codeSubmit.bind(this)}
                />
                <InsuranceModal
                    modal={this.state.insuranceModal}
                    onClose={()=>this.setState({insuranceModal:false})}
                    data={this.state.insuranceData}
                    index={this.state.insuranceIndex}
                />
                <PriceModal
                    modal={this.state.priceModal}
                    onClose={()=>this.setState({priceModal:false})}
                    priceInfo={this.state.priceInfo}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/SelectSeat/index.js